import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function resetScrollTrigger() {
  ScrollTrigger.refresh()
}

let timeout = false
let delay = 250
window.addEventListener('resize', () => {
  clearTimeout(timeout)
  timeout = setTimeout(resetScrollTrigger, delay)
})
window.addEventListener('orientationchange', resetScrollTrigger, false)
